"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const SearchResult = ({ title, onItemWasAdded, onAddClicked, roles, addButtonText }) => (react_1.default.createElement("div", { className: 'search-result' },
    react_1.default.createElement("div", { className: 'item-head' },
        react_1.default.createElement("p", { className: 'bold' }, title),
        !onItemWasAdded(title) && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary-small', onClick: () => onAddClicked(title) }, addButtonText ? addButtonText : 'Add'))),
    react_1.default.createElement("ul", { className: 'item-content' }, roles &&
        roles.map((role) => (react_1.default.createElement("li", { key: role.name },
            react_1.default.createElement("span", null,
                role.name,
                ":"),
            react_1.default.createElement("strong", null, role.value)))))));
exports.default = (0, mobx_react_1.observer)(SearchResult);
